export default {
  "content": "<path d=\"M3.47 2.57a1.58 1.58 0 11-3.16 0 1.58 1.58 0 013.16 0zm8.03 0a1.58 1.58 0 11-3.15 0 1.58 1.58 0 013.16 0zM3.47 9A1.58 1.58 0 11.31 9a1.58 1.58 0 013.16 0zm8.03 0a1.58 1.58 0 11-3.15 0 1.58 1.58 0 013.16 0zm-8.03 6.43a1.58 1.58 0 11-3.16 0 1.58 1.58 0 013.16 0zm8.03 0a1.58 1.58 0 11-3.15 0 1.58 1.58 0 013.16 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "18",
    "fill": "#D6D6D6",
    "viewBox": "0 0 12 18"
  }
};